export default __webpack_public_path__ + "img/9.b6967212.jpg";